itsoftApp.createModule("scrollActions", ["startLoad"], function () {
    var module = this;
    var registeredPlugin = false;
    var registeredScrollTriggerPlugin = false;
    var headerHeight = itsoftApp.utils.getHeaderHeight();

    const libraries = {
        gsap: {
            name: "gsap",
            queue: [],
            started: false,
            loaded: false,
            scriptMore: "/assets/scripts/gsap/ScrollTrigger.min.js",
            script: "/assets/scripts/gsap/gsap.min.js"
        }
    }

    itsoftApp.modules.windowResize.addEvent(function () {
        headerHeight = itsoftApp.utils.getHeaderHeight();
    });

    var initScrollActions = function (element, scrollTriggerFlag, cb) { 
        const initScrollExemplar = function () {
            if (!registeredPlugin) {
                registeredPlugin = true;

                if (!registeredScrollTriggerPlugin && scrollTriggerFlag) {
                    // регистрируем дополнительный плагин, чтобы анимации работали при скролле
                    gsap.registerPlugin(ScrollTrigger);
                }
            }

            if (cb && typeof cb === "function") {
                cb();
            } else {
                if (element.classList.contains("js-clock")) {
                    const clockHand = element.querySelector(".js-clock-hand");
                    const count = element.querySelector(".js-count");
                    var number = count.getAttribute("data-number-target");
                    var firstEnterFlag = false;

                    ScrollTrigger.create({
                        trigger: element,
                        start: "top center",
                        once: true,
                        onEnter: function () {
                            element.classList.add("js-active");

                            var options = {
                                draw: function (progress) { /* анимируем в зависимости от времени и временной функции */
                                    count.textContent = parseInt((progress * number), 10);
                                },
                                timing: function(timeFraction) {
                                    return 1 - (1 - timeFraction);
                                },
                                duration: 3000
                            }
                            itsoftApp.modules.animations.callback(options);
                        }
                    });
                }

                if (element.classList.contains("js-sequence")) {
                    const canvas = element.querySelector(".js-pack-canvas");
                    const context = canvas.getContext("2d");

                    canvas.width = 1520;
                    canvas.height = 924;

                    const frameCount = 7;
                    const currentFrame = index => (
                    `/media/images/sequence/${(index + 1)}.png`
                    );

                    const images = []
                    const pack = {
                        frame: 0
                    };

                    for (let i = 0; i < frameCount; i++) {
                        const img = new Image();
                        img.src = currentFrame(i);
                        images.push(img);
                    }

                    gsap.to(pack, {
                        frame: frameCount - 1,
                        snap: "frame",
                        ease: "none",
                        scrollTrigger: {
                            trigger: element,
                            scrub: 0.5,
                            start: "55% center",
                            end: "75% center"
                        },
                        onUpdate: render // use animation onUpdate instead of scrollTrigger's onUpdate
                    });

                    images[0].onload = render;

                    function render() {
                        context.clearRect(0, 0, canvas.width, canvas.height);
                        context.drawImage(images[pack.frame], 0, 0); 
                    }
                }

                if (element.classList.contains("js-scroll-parallax")) {
                    gsap.to(".js-parallax-item", {
                        scrollTrigger: {
                            trigger: element,
                            scrub: true
                        }, 
                        y: (i, target) => -ScrollTrigger.maxScroll(window) * target.dataset.speed,
                        ease: "none"
                    });
                }

                if (element.classList.contains("js-hash-nav")) {
                    let links = gsap.utils.toArray("[data-color]");
                        
                    links.forEach((a, index) => {
                        let element = document.querySelector(a.getAttribute("href"));
                        // let linkST = ScrollTrigger.create({
                        //     trigger: element,
                        //     start: "top top"
                        // });

                        ScrollTrigger.create({
                            trigger: element,
                            start: "top top+=140px",
                            end: "bottom top+=140px",
                            onToggle: self => self.isActive && setActive(a, index)
                        });

                    });

                    function setActive(link, index) {
                        links.forEach(el => el.classList.remove("js-active"));
                        link.classList.add("js-active");
                    }
                }
            }
        }

        new itsoftApp.modules.startLoad.callback(initScrollExemplar, libraries.gsap);
    }

    module.callback = initScrollActions;
});